__turbopack_context__.v({
  "rounded": "input-quantity-module-scss-module__3pIGWa__rounded",
  "roundedLabel": "input-quantity-module-scss-module__3pIGWa__roundedLabel",
  "u-animation-bounce": "input-quantity-module-scss-module__3pIGWa__u-animation-bounce",
});
